import { NSARouterMakerResult } from "namirasoft-account-react";
import { ClassifierInputRow, ClassifierRow } from "namirasoft-inference";
import { Component } from "react";
import ClassifierClassesViewLoader from "../components/ClassifierClassesViewLoader";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface ClassifierListPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class ClassifierListPage extends Component<ClassifierListPageProps>
{
    override render()
    {
        return (
            <InferenceLayout<ClassifierRow, ClassifierInputRow>
                {...this.props}
                action={{ description: InferenceInfo.classifier.list }}
                pages={{
                    entity: InferenceEntities.classifier(this.props),
                    list: {
                        ui: {
                            getChildrenAfter: (id, _row) =>
                            {
                                if (!id)
                                    return null;
                                return (
                                    <div style={{ flexBasis: "100%", width: "100%" }}>
                                        <ClassifierClassesViewLoader
                                            {...this.props}
                                            classifier_id={id}
                                        />
                                    </div>
                                );
                            },
                        },
                    }
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}